import { render, staticRenderFns } from "./dashTopPptList.vue?vue&type=template&id=38c221a9"
import script from "./dashTopPptList.vue?vue&type=script&lang=js"
export * from "./dashTopPptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports